import Image from "components/Image"
import { getAllNewsArticlePaths, getNewsArticle, getGlobals } from "storyblok/api"
import richText from "utilities/richText"
import Meta from "components/Meta"
import CTABanner from "components/DynamicComponent/atoms/CTABanner"
import { Crumb } from "components/Breadcrumbs"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import { formatNewsDate } from "utilities/newsHelpers"
import { getExcerpt } from "utilities/getExcerpt"
import isRichTextValid from "utilities/isRichTextValid"

export default function Article({ story, meta }) {
  return (
    <>
      <Meta
        info={{
          title: meta?.title && meta?.title !== "" ? meta?.title : story?.content?.title,
          description:
            meta?.description && meta?.description !== ""
              ? meta?.description
              : getExcerpt(story?.content?.article_type?.[0]?.content),
          og_title: meta?.title && meta?.title !== "" ? meta?.title : story?.content?.title,
          og_description:
            meta?.description && meta?.description !== ""
              ? meta?.description
              : getExcerpt(story?.content?.article_type?.[0]?.content),
          og_image: story?.content?.featured_image?.filename ?? null,
          twitter_title: meta?.title && meta?.title !== "" ? meta?.title : story?.content?.title,
          twitter_description:
            meta?.description && meta?.description !== ""
              ? meta?.description
              : getExcerpt(story?.content?.article_type?.[0]?.content),
          twitter_image: story?.content?.featured_image?.filename ?? null,
        }}
      />
      <nav aria-label="Breadcrumb" className="px-6 py-6">
        <ol className="mx-auto w-full max-w-screen-xl">
          <Crumb {...{ text: "Home", href: "/" }} />
          <Crumb {...{ text: "Latest News", href: "/news/page/1" }} />
          <Crumb {...{ text: story?.content?.title, href: `/news/${story?.content?.slug}`, last: true }} />
        </ol>
      </nav>
      <main data-pagefind-body>
        <StoryblokVisualEditor story={story?.content}>
          <section className="px-6 pb-18">
            <div className="mx-auto max-w-screen-md">
              {story?.content?.date && story?.content?.date !== "" ? (
                <time dateTime={story?.content?.date} className="font-tertiary uppercase">{`${formatNewsDate(
                  story?.content?.date,
                )}`}</time>
              ) : null}
              <h1 className="pb-4 pt-2.5 text-teal-dark">{story?.content?.title}</h1>
              <StoryblokVisualEditor story={story?.content?.article_type}>
                <div className="content prose-ul:list marker:text-gray-dark marker:text-sm pb-8 prose-h2:pb-0 prose-h2:pt-8 prose-h2:text-l2 prose-h3:pb-8 prose-h3:pt-4 prose-h3:uppercase prose-p:py-2 prose-a:overflow-x-visible prose-a:pr-0 prose-a:normal-case prose-a:underline prose-a:before:hidden prose-a:after:hidden hover:prose-a:no-underline prose-ul:list-disc prose-ul:pl-4">
                  {richText(story?.content.article_type?.[0]?.content)}
                </div>
              </StoryblokVisualEditor>
              {story?.content?.featured_image?.filename ? (
                <Image
                  placeholder={story?.content?.featured_image?.blurDataURL ? "blur" : "empty"}
                  blurDataURL={story?.content?.featured_image?.blurDataURL}
                  src={story?.content?.featured_image?.filename}
                  alt={story?.content?.featured_image?.alt}
                  width={715}
                  height={572}
                  className="w-full pb-2"
                />
              ) : null}
              {isRichTextValid(story?.content?.image_caption) ? (
                <div className="prose-p:pb-1">{richText(story?.content?.image_caption)}</div>
              ) : null}
            </div>
          </section>
        </StoryblokVisualEditor>
      </main>
      <CTABanner />
    </>
  )
}

export async function getStaticProps({ params: { slug }, preview = null }) {
  const globals = await getGlobals()
  const story = await getNewsArticle(slug, preview)

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllNewsArticlePaths(),
    fallback: false,
  }
}
